/* ProbabilityGauge — clean circular gauge for case success probability.
   No halo, no drop-shadow, no ticks. Just a subtle track + a colored arc
   that fills from 0 up to the value, with the percentage centered inside.
   Colors map to bands:
     0–24%:  red
     25–49%: orange
     50–74%: yellow
     75–100%: green
*/

export function probBand(p) {
  if (p === null || p === undefined) return null;
  if (p < 25)  return { color: "#EF4444", label: "احتمالية ضعيفة" };  // red (0–24)
  if (p < 50)  return { color: "#F97316", label: "احتمالية محدودة" }; // orange (25–49)
  if (p < 75)  return { color: "#FACC15", label: "احتمالية متوسطة" }; // yellow (50–74)
  return         { color: "#22C55E", label: "احتمالية قوية" };          // green (75–100)
}

export default function ProbabilityGauge({ value, band, testid }) {
  const r = 34;
  const C = 2 * Math.PI * r;
  const dash = C * (value / 100);
  const gap = C - dash;
  return (
    <div
      className="shrink-0 flex flex-row-reverse items-center gap-1.5"
      data-testid={testid}
      aria-label={band.label}
      title={band.label}
    >
      <div className="relative w-[51px] h-[51px]" style={{ direction: "ltr" }}>
        <svg viewBox="0 0 80 80" className="w-full h-full">
          {/* faint track */}
          <circle
            cx="40" cy="40" r={r}
            stroke="#E5E7EB" strokeWidth="6" fill="none"
            transform="rotate(-90 40 40)"
          />
          {/* colored arc — single solid color of the band */}
          <circle
            cx="40" cy="40" r={r}
            stroke={band.color} strokeWidth="6" fill="none"
            strokeDasharray={`${dash} ${gap}`}
            strokeLinecap="round"
            transform="rotate(-90 40 40)"
            style={{ transition: "stroke-dasharray 900ms cubic-bezier(0.22,1,0.36,1)" }}
          />
          {/* number — drawn inside the SVG so it is mathematically centered.
              We use textAnchor=middle for horizontal center + the dy=0.35em
              baseline-nudge trick which centers ALL browsers reliably (some
              older Safari versions ignore dominantBaseline=central). */}
          <text
            x="40" y="40" dy="0.35em"
            textAnchor="middle"
            fill="#0A192F"
            fontFamily="Tajawal, sans-serif"
            fontWeight="700"
            fontSize="26"
          >
            {value}
          </text>
        </svg>
      </div>
      <span className="text-[11px] font-bold text-[#5A6470] text-center leading-tight whitespace-nowrap">
        ٪ للنجاح
      </span>
    </div>
  );
}
